import { API } from 'javascripts/api'

// 案件カード全体が案件詳細へのリンクになっているため、お気に入りボタンのクリックでは
// 遷移を抑止し、お気に入りAPIの呼び出しと表示状態の切り替えだけを行う。
export const setupFavoriteButtons = (): void => {
  document.querySelectorAll<HTMLElement>('.card.job-card').forEach(card => {
    const jobOfferId = Number(card.dataset.jobOfferId)
    const button = card.querySelector<HTMLAnchorElement>('.favorite-btn')
    if (!button || !jobOfferId) return

    button.addEventListener('click', event => {
      event.preventDefault()
      event.stopPropagation()

      const isFavorite = button.classList.contains('active')
      button.classList.toggle('active', !isFavorite)

      const request = isFavorite
        ? API.deleteJobOffersFavorite(jobOfferId)
        : API.updateJobOffersFavorite(jobOfferId)

      request.catch(() => {
        button.classList.toggle('active', isFavorite)
      })
    })
  })
}
